import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Link,
  Button,
  Drawer,
  Typography,
  Avatar,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from '@mui/material';
// components
import { connect } from 'react-redux';
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import { genSidebarConfig } from './SidebarConfig';
import account from '../../_mocks_/account';
import { Loading } from '../../components/Loading';
import { fUserRole } from '../../utils/formatEnums';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200]
}));

// ----------------------------------------------------------------------

function DashboardSidebar({
  isOpenSidebar,
  onCloseSidebar,
  properties,
  selectedProperty,
  selectProperty,
  propertiesLoading,
  currentRole
}) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleSelectedPropertyChange = (event) => {
    const id = event.target.value;
    const property = properties.find((p) => p.id === id);
    selectProperty(property);
  };

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column' }
      }}
    >
      <Box sx={{ px: 2.5, py: 3 }}>
        <Box component={RouterLink} to="/" sx={{ display: 'inline-flex' }}>
          <Logo />
        </Box>
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        {propertiesLoading ? (
          <Loading centered />
        ) : (
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Propiedad</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedProperty && selectedProperty.id}
              label="Age"
              onChange={handleSelectedPropertyChange}
            >
              {properties && properties.map((p) => <MenuItem value={p.id}>{p.name}</MenuItem>)}
            </Select>
          </FormControl>
        )}

        {/* <Box sx={{ mt: 2 }}> */}
        {/*  {profileLoading || !profile ? ( */}
        {/*    <Loading /> */}
        {/*  ) : ( */}
        {/*    <> */}
        {/*      <Typography variant="subtitle2" sx={{ color: 'text.primary' }}> */}
        {/*        {profile.firstName} {profile.lastName} */}
        {/*      </Typography> */}
        {/*      <Typography variant="body2" sx={{ color: 'text.secondary' }}> */}
        {/*        {fUserRole(currentRole)} */}
        {/*      </Typography> */}
        {/*    </> */}
        {/*  )} */}
        {/* </Box> */}
      </Box>
      {/* <Divider sx={{ mb: 1 }} /> */}

      {/* <Box sx={{ mb: 5, mx: 2.5 }}> */}
      {/* <Link underline="none" component={RouterLink} to="#"> */}
      {/*   <AccountStyle> */}
      {/*     <Box sx={{ ml: 2 }}> */}
      {/*       {profileLoading || !profile ? ( */}
      {/*         <Loading /> */}
      {/*       ) : ( */}
      {/*         <> */}
      {/*           <Typography variant="subtitle2" sx={{ color: 'text.primary' }}> */}
      {/*             {profile.firstName} {profile.lastName} */}
      {/*           </Typography> */}
      {/*           <Typography variant="body2" sx={{ color: 'text.secondary' }}> */}
      {/*             {fUserRole(currentRole)} */}
      {/*           </Typography> */}
      {/*         </> */}
      {/*       )} */}
      {/*     </Box> */}
      {/*   </AccountStyle> */}
      {/* </Link> */}
      {/* </Box> */}

      {currentRole ? (
        <NavSection navConfig={genSidebarConfig(currentRole)} />
      ) : (
        <Loading centered />
      )}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default'
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
  fetchProperties: PropTypes.func
};

const mapState = (state) => ({
  isLoggedIn: state.auth.isLoggedIn,
  properties: state.property.managedList,
  selectedProperty: state.property.selectedProperty,
  propertiesLoading: state.loading.effects.property.fetchAllWhereImAdminOrCustodian.loading,
  currentRole: state.property.currentRole
});

const mapDispatch = (dispatch) => ({
  fetchLogsByPropertyId: dispatch.logs.fetchByPropertyId,
  selectProperty: dispatch.property.select
});

export default connect(mapState, mapDispatch)(DashboardSidebar);
